import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ordencompra-spa';
  constructor(private router: Router,
              private gtmService: GoogleTagManagerService
  ) {

    this.router.events.forEach(item => {
      
      if (item instanceof NavigationEnd) {

        const gtmTag = {
          event: 'page',
          pageName: item.url
        };
        this.gtmService.pushTag(gtmTag);
      }
    });
  }

  public ngOnInit() {
    localStorage.removeItem('FiltrosOc');
  }

}
